import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import EnquiryModal from "../components/EnquiryModal";

const EnquiryModalContext = createContext(null);

export function EnquiryModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openEnquiryModal = useCallback(() => setOpen(true), []);
  const closeEnquiryModal = useCallback(() => setOpen(false), []);

  const value = useMemo(
    () => ({ openEnquiryModal, closeEnquiryModal }),
    [openEnquiryModal, closeEnquiryModal],
  );

  return (
    <EnquiryModalContext.Provider value={value}>
      {children}
      <EnquiryModal open={open} onClose={closeEnquiryModal} />
    </EnquiryModalContext.Provider>
  );
}

export function useEnquiryModal() {
  const ctx = useContext(EnquiryModalContext);
  if (!ctx) {
    throw new Error("useEnquiryModal must be used within EnquiryModalProvider");
  }
  return ctx;
}
